import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TEmitterTypeValueType } from '@semios/app-platform-values-helpers-and-types'
import type { TIrrigationDeviceStatus, TValuesCurrentIrrigationZones } from 'App/Map/types'
import { translate } from 'i18n/i18n'
import { minutesToHoursAndMinutes } from 'utils/minutesToHoursAndMinutes'
import {
  IRRIGATION_ZONE_ACTIVITY_APPLIED_EVENT_DURATION_VALUE_TYPE_PREFIX,
  IRRIGATION_ZONE_ACTIVITY_PUBLISHED_EVENT_DURATION_VALUE_TYPE_PREFIX,
} from '../_utils/irrigationActivityConstants'
import { getIrrigationStatusReturn } from './getIrrigationStatusReturn'

export const getStatusValue = ({
  irrigationZoneValueType,
  id,
  irrigationZoneValuesFromResponse,
}: {
  irrigationZoneValueType: TValuesCurrentIrrigationZones
  id: string
  irrigationZoneValuesFromResponse: NonNullable<routes.ValuesCurrent.Response['irrigation_zones']>[number]
}) => {
  const statusValue = irrigationZoneValuesFromResponse['irrigationIsOn_status']?.value ?? null
  const emitterType = irrigationZoneValueType.split('_')[1] as TEmitterTypeValueType

  const appliedValueType =
    `${IRRIGATION_ZONE_ACTIVITY_APPLIED_EVENT_DURATION_VALUE_TYPE_PREFIX}${emitterType}_ms` as const

  const publishedValueType =
    `${IRRIGATION_ZONE_ACTIVITY_PUBLISHED_EVENT_DURATION_VALUE_TYPE_PREFIX}${emitterType}_ms` as const

  const publishedDurationInMs = irrigationZoneValuesFromResponse?.[appliedValueType]?.value ?? 0
  const appliedEventDuration = irrigationZoneValuesFromResponse?.[publishedValueType]?.value ?? 0

  if (!publishedDurationInMs) {
    return {
      id: String(id),
      value: {
        [irrigationZoneValueType]: getIrrigationStatusReturn(statusValue as TIrrigationDeviceStatus),
      },
    }
  }

  const totalMinutesFormatted = minutesToHoursAndMinutes(publishedDurationInMs / 60000)
  const calculatedElapsedTime = minutesToHoursAndMinutes(appliedEventDuration / 60000)

  const progressText = translate.phrases.templates('{{passedTime}} of {{totalTime}}', {
    passedTime: calculatedElapsedTime,
    totalTime: totalMinutesFormatted,
  })

  const percentPassed = Math.round((appliedEventDuration / publishedDurationInMs) * 100)

  return {
    id: id,
    value: {
      [irrigationZoneValueType]: {
        ...getIrrigationStatusReturn(statusValue as TIrrigationDeviceStatus),
        progressText,
        progressPercent: percentPassed,
      },
    },
  }
}
